<!--
 * @Descripttion: 
 * @version: 
 * @Author: zouxin
 * @email: 1294644276@qq.com
 * @Date: 2024-12-11 10:08:25
 * @LastEditors: zouxin
 * @LastEditTime: 2024-12-17 09:16:33
-->
<!--
 * @Descripttion: 密码重置组件
 * @version: 3.0
 * @Author: zhangfan
 * @email: 2207044692@qq.com
 * @Date: 2024-11-27 17:21:16
 * @LastEditors: zouxin
 * @LastEditTime: 2024-12-16 16:11:44
-->
<template>
  <div class="login-form-wrapper">
    <a-form-model :model="form" :rules="rules" ref="loginForm" layout="vertical" class="login-form">
      <a-form-model-item prop="firstPassword">
        <a-input-password
          v-model="form.firstPassword"
          :placeholder="$t('base.pleaseInputNewPassword')"
          allow-clear
          hide-button
        ></a-input-password>
      </a-form-model-item>
      <a-form-model-item prop="secondPassword" style="margin-top: 10px">
        <a-input-password v-model="form.secondPassword" :placeholder="$t('base.confirmNewPassword')" allow-clear>
        </a-input-password>
      </a-form-model-item>
      <!-- <div class="register-box">
        <div style="font-size: 14px; color: #a2a5ae">{{ $t('base.noCode') }}</div>
        <div style="font-size: 14px; color: #a2a5ae">
          {{ $t('base.haveAccount')
          }}<span class="register-link" @click="skipToLoginPage">{{ $t('base.pleaseLogin') }}</span>
        </div>
      </div> -->
      <a-button style="font-size: 14px" type="primary" class="sbmitBtn" @click="handleSubmit">{{
        $t('base.confirm')
      }}</a-button>
    </a-form-model>
  </div>
</template>

<script>
import { resetPassword, familyresetPassword } from '@/api/auth'
import { getComToken, transferComtoken } from '@/utils/comToken'
import { getToken, setToken } from '@/utils/auth'
import aes from '@/utils/aes'
export default {
  data() {
    return {
      form: {
        firstPassword: '',
        secondPassword: '',
      },
      countdown: 0,
      errorMessage: '',
    }
  },
  computed: {
    isAgree() {
      return this.$store.getters.LoginInfo.isAgree
    },
    isCountingDown() {
      return this.countdown > 0 || false
    },
    loginConfig() {
      return this.$store.getters.loginConfig
    },
    rules() {
      return {
        firstPassword: [
          { required: true, message: this.$t('base.pleaseSetNewPassword'), trigger: 'blur' },
          { validator: this.validateFirstPassword, trigger: 'blur' },
        ],
        secondPassword: [
          { required: true, message: this.$t('base.pleaseConfirmNewPassword'), trigger: 'blur' },
          { validator: this.validateSecondPassword, trigger: 'blur' },
        ],
      }
    },
  },
  methods: {
    // 新密码校验
    validateFirstPassword(rule, value, callback) {
      const passwordValidate =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-])[A-Za-z\d@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-]{8,}$/
      if (!passwordValidate.test(value)) {
        callback(this.$t('base.passwordRule', [8, 16]))
      }
      if (this.form.secondPassword !== '') {
        if (this.form.secondPassword !== value) {
          callback(this.$t('base.passwordNotSame'))
        }
      }
      callback() // Validation passed
    },

    //确认密码校验
    validateSecondPassword(rule, value, callback) {
      const passwordValidate =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-])[A-Za-z\d@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-]{8,}$/
      if (this.form.firstPassword !== value) {
        callback(this.$t('base.passwordNotSame'))
      } else if (!passwordValidate.test(value)) {
        callback(this.$t('base.passwordRule', [8, 16]))
      }
      callback() // Validation passed
    },

    // 去登录
    skipToLoginPage() {
      this.$router.push({
        path: '/login',
      })
    },

    // 提交登录
    handleSubmit() {
      const _this = this
      _this.$refs.loginForm.validate(async (valid) => {
        try {
          if (valid) {
            let key = aes.decrypt(this.loginConfig.key, 'cbim2192cbim2192')
            let res = await resetPassword({
              accessToken: getToken() && getToken().replace('Bearer ', ''),
              clientId: this.loginConfig.clientId,
              password: aes.sm4Encrypt(this.form.firstPassword, key),
            })
            if (res.code === 0) {
              let res2 = await familyresetPassword({
                password: aes.encrypt(this.form.firstPassword, 'cbim2192cbim2192'),
                confirmPassWord: aes.encrypt(this.form.secondPassword, 'cbim2192cbim2192'),
              })
              this.$message.success(this.$t('tip.resetSuccess'))
              this.skipToLoginPage()
            } else {
              this.$message.error(res.msg)
            }
          } else {
            return false
          }
        } catch (error) {
          console.log(error)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.login-form {
  margin-top: 20px;
  font-size: 18px;

  .incocss {
    font-size: 18px;
    margin-right: 3px;
  }

  &-wrapper {
    width: 360px;
    color: #fff;
  }

  /deep/.ant-input {
    height: 40px;
  }
}
.buttonCodeClass {
  font-size: 18px;
}

.register-box {
  width: 320px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 10px;
  position: relative;
  // bottom: 30px;
  padding: 0px 5px;

  .register-link {
    color: #0166fc;
    cursor: pointer;
  }
}

.sbmitBtn {
  width: 360px;
  height: 40px;
  background: #0166fc;
  border-radius: 8px 8px 8px 8px;
}

.send-code {
  cursor: pointer;
}

/deep/.ant-form-item-label > label {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #a2a5ae;
}
</style>
